import BigNumber from 'bignumber.js';

/**
 * PRIME = 2**251 + 17 * 2**192 + 1
 * @source https://github.com/tradeparadigm/mono/blob/9576d87e0f8a9fa8e669d8a34039cc86feff448d/api/paradex/contracts/cairo/tests/utils.py#L15
 */
export const PRIME = new BigNumber(
  '3618502788666131213697322783095070105623107215331596699973092056135872020481',
);

/**
 * Returns the lift of the given field element, val, as an integer
 * in the range (-prime/2, prime/2).
 * @source https://github.com/tradeparadigm/mono/blob/9576d87e0f8a9fa8e669d8a34039cc86feff448d/api/paradex/contracts/cairo/tests/utils.py#L173-L178
 */
export function asInt(value: string): string {
  const valueBN = new BigNumber(value);

  if (valueBN.isLessThan(PRIME.dividedToIntegerBy(2))) {
    return valueBN.toFormat();
  }

  return valueBN.minus(PRIME).toFormat();
}
